import styled from 'styled-components';
import {
  display,
  dimension,
  padding,
  margin,
  flexParent,
  flexChild,
} from '../styleHelper2';

const style = props => {
  const { theme } = props;

  const states = {
    default: `
      color: ${theme.text.text300};
      background-color: ${theme.background.background100};
      border-color: ${theme.border.border400};
    `,
    info: `
      color: ${theme.text.normal};
      background-color: ${theme.primary.primary100};
      border-color: ${theme.primary.primary200};
    `,
    success: `
      color: ${theme.secondary.normal};
      background-color: ${theme.secondary.secondary100};
      border-color: ${theme.secondary.normal};
    `,
    error: `
      color: ${theme.error.normal};
      background-color: ${theme.error.error100};
      border-color: ${theme.error.normal};
    `,
  };
  const state = Object.keys(states).find(key => props[key]) || 'default';

  return states[state];
};

const Tag = styled.div`
  display: inline-block;
  padding-left: ${props => props.theme.padding.normal};
  padding-right: ${props => props.theme.padding.normal};
  padding-top: ${props => props.theme.padding.small};
  padding-bottom: ${props => props.theme.padding.small};
  font-size: ${props => props.theme.fontSize.small};
  border-style: solid;
  border-width: 1px;
  border-radius: 2em;
  ${display()}
  ${dimension()}
  ${margin()}
  ${padding()}
  ${flexParent()}
  ${flexChild()}
  ${style}
`;

export default Tag;
